import React from 'react';
import {Navigate, RouteObject} from 'react-router';
import App from './app';
import LoginController from './components/login/loginController';
import AuthRoute from './components/misc/authRoute';
import WaitlistController from './components/waitlist/waitlistController';
import {LOGIN_PATH, LOGIN_ROUTE, WAIT_LIST_PATH} from './util/constants';

export const Routes: Array<RouteObject> = [
    {
        path: '*', element: <App/>, children: [
            {path: LOGIN_PATH, element: <LoginController/>},
            {path: WAIT_LIST_PATH, element: <AuthRoute><WaitlistController/></AuthRoute>},
            {path: '*', element: <Navigate to={LOGIN_ROUTE}/>}
        ]
    }
];